module.exports = __webpack_public_path__ + "static/media/icon-open-down.5df08885.svg";